import useChatRestClient from '@/Api/ChatRestClient';
import {useMutation} from '@tanstack/react-query';

export default function useSubmitCallFeedback(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (data: any) => void,
) {
  const ChatRestClient = useChatRestClient();
  type SubmitFeedbackResponse = {
    success: boolean;
    [key: string]: any;
  };

  const mutation = useMutation<SubmitFeedbackResponse>(
    async payload => {
      const response = await ChatRestClient.post(
        'subscription/v1/submit-mentor-call-feedback',
        payload,
      );
      return response.data;
    },
    {
      onSuccess: data => {
        if (handleOnSuccess && data?.success) {
          handleOnSuccess(data);
        } else if (handleOnError) {
          handleOnError(data);
        }
      },
    },
  );

  return {
    ...mutation,
  };
}
